import React from 'react';
import styled from 'styled-components';

import LocalizedNumber from 'common/components/LocalizedNumber';

type Props = {
  amount: number;
  currency: Currency;
  numberFormatOptions?: Intl.NumberFormatOptions;
};

const Root = styled.span`
  white-space: nowrap;
`;

const MonetaryAmount = ({ amount, currency, numberFormatOptions = {} }: Props) => (
  <Root>
    <LocalizedNumber
      value={amount}
      options={{
        ...numberFormatOptions,
        style: 'currency',
        currency,
        currencyDisplay: 'symbol',
      }}
    />
  </Root>
);

export default MonetaryAmount;
